/**
 * Людські назви ролі користувача в акаунті (tenant) — ЄДИНЕ джерело для
 * шапки, «Облікового запису» і (дзеркально) бекенду /auth/my-tenants.
 *
 * ч.1072 (зауваження власника: «неоднозначно пише роль — бухгалтер
 * зареєструвався, організацій не завів, а він «Власник»»): роль стосується
 * АКАУНТА в системі, а не бізнесу. Хто зареєструвався — власник акаунта
 * (підписка, користувачі, організації), навіть якщо він бухгалтер, а не
 * власник бізнесу. MEMBER — «Користувач» (раніше в одних місцях
 * «Користувач», в інших «Співробітник»; запрошений бухгалтер клієнта —
 * не співробітник).
 */
export const TENANT_ROLE_LABELS: Record<string, string> = {
  OWNER: 'Власник акаунта',
  ADMIN: 'Адміністратор',
  MEMBER: 'Користувач',
};

export function tenantRoleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return TENANT_ROLE_LABELS[role] ?? role;
}
